import { FC } from "react";
import { Box, Flex, Image } from "@chakra-ui/react";
import Arrow from "~/images/arrow-curved-bottom-right-peach.svg";
import { HeadingWithHighlight } from "~/OnboardingApp/components";

export const Title: FC = () => {
  return (
    <Flex justify="center" w="full">
      <Flex position="relative" w="fit-content">
        <HeadingWithHighlight
          highlightColor="var(--chakra-colors-newBlue-100)"
          i18nKey="onboarding.welcomeNamePage.heading"
        />
        <Box
          display={{ base: "none", lg: "initial" }}
          position="absolute"
          left="-4.25rem"
          top="0"
        >
          <Image alt="Bottom right arrow" src={Arrow} />
        </Box>
      </Flex>
    </Flex>
  );
};
